// CSS editor: CodeMirror with CSS syntax highlighting, following the app
// theme. The aria-label rides on the editor's contenteditable (via
// contentAttributes) so the field stays queryable by its visible label.

import { css } from "@codemirror/lang-css";
import { EditorView } from "@codemirror/view";
import CodeMirror from "@uiw/react-codemirror";
import { useTheme } from "next-themes";
import { useMemo } from "react";

export interface CssEditorProps {
    value: string;
    onChange: (value: string) => void;
    ariaLabel: string;
}

export function CssEditor({ value, onChange, ariaLabel }: CssEditorProps) {
    const { resolvedTheme } = useTheme();
    const extensions = useMemo(
        () => [css(), EditorView.contentAttributes.of({ "aria-label": ariaLabel })],
        [ariaLabel],
    );
    return (
        <div className="overflow-hidden rounded-kore-control border border-kore-field-border">
            <CodeMirror
                value={value}
                onChange={onChange}
                extensions={extensions}
                theme={resolvedTheme === "dark" ? "dark" : "light"}
                minHeight="16rem"
                maxHeight="40rem"
                basicSetup={{ foldGutter: false, searchKeymap: false }}
                aria-label={ariaLabel}
            />
        </div>
    );
}
